import type { UseWidget } from '@swf/core/hooks/useWidget';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { WidgetModelConfig } from '@swf/core/store';
import type { BasicSportsWidgetConfig } from '@swf/sports/pages/types';

import { defaultState } from './defaultState';
import { effects } from './effects';
import { reducers } from './reducers';
import { selectors } from './selectors';
import type { SportsFeaturedState } from './types';

export interface SportsFeaturedWidgetModel
  extends WidgetModelConfig<BasicSportsWidgetConfig, SportsFeaturedState> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

export const sportsFeaturedWidgetModel: SportsFeaturedWidgetModel = {
  state: defaultState,
  reducers,
  effects,
  selectors
};

export const useSportsFeaturedWidget: UseWidget<
  BasicSportsWidgetConfig,
  SportsFeaturedWidgetModel
> = useWidget;
